import { DateTime } from "luxon";

export const isoDateTimeToLocal = (timestamp = "") => {
  return (
    DateTime.fromISO(timestamp, { setZone: true })
      .toLocal()
      .toFormat("MM/dd/yyyy hh:mm a") ?? ""
  );
};
